// ThreeEvaluationCards.tsx

import React, { useEffect } from 'react';
import { Card, CardContent, CardHeader, IconButton, Tooltip } from '@material-ui/core';
import { Panel } from '../../../../../Components/Panel/Panel';
import { useIntl } from 'react-intl';
import { Form, HtmlView, Loading } from '../../../../../Components';
import { useFormField } from '../../../../../Components/Form/FormField';
import { Edit } from '@material-ui/icons';
import { useStyles } from './List.styles';
import { useEvaluationCardState } from './evalutionState';

// editMode alag component mein nikalo taaki mount/unmount ho
const ThreeEvaluationCards = () => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const { data, editingData, loading, editMode, submit, startEdit, cancelEdit } = useEvaluationCardState();
 useEffect(() => {
    if (!loading && !data) {
      startEdit();
    }
  }, [loading, data]);
  return (
    <Panel titleKey="admin.law-portal.subMenu.settings.threeevealutioncard" accordion>
      {loading ? (
        <Loading />
      ) : editMode ? (
        // ✅ key={editingData} — jab editingData set ho tab fresh mount hoga
        <EvaluationForm
          key={editingData ?? 'empty'}
          editingData={editingData}
          submit={(form, api, onSuccess) => submit(form, api, onSuccess, formatMessage)}
          cancelEdit={cancelEdit}
        />
      ) : (
        <Card variant="outlined" className={classes.root}>
          <CardHeader
            action={
              <Tooltip title={formatMessage({ id: 'utils.icon.edit', defaultMessage: 'Edit' })}>
                <IconButton
                  aria-label={formatMessage({ id: 'utils.icon.edit', defaultMessage: 'Edit' })}
                  onClick={startEdit}
                >
                  <Edit fontSize="small" />
                </IconButton>
              </Tooltip>
            }
          />
          <CardContent>
            <HtmlView value={data} />
          </CardContent>
        </Card>
      )}
    </Panel>
  );
};

const EvaluationForm = ({
  editingData,
  submit,
  cancelEdit,
}: {
  editingData: any;
  submit: any;
  cancelEdit: () => void;
}) => {
  const { formatMessage } = useIntl();

  const chapter = useFormField({
    label: formatMessage({
      id: 'admin.law-portal.informationBoard.form.message.label',
      defaultMessage: 'Message',
    }),
    name: 'EvaluationInformation',
    type: 'rich-text',
    required: true,
    richTextEditorHeight: 'small',
    initialState: editingData ? { value: editingData, label: editingData, isValid: true } : undefined, // ✅ mount pe available
  });

  return (
    <Form
      submit={submit}
      cancel={cancelEdit}
      groups={[{ grid: { type: 'column', items: [chapter] } }]}
    />
  );
};

export default ThreeEvaluationCards;